import { Badge, InlineStack, Link, Paragraph, Stack } from '@customerio/pluma-components/react';
import { AttributeTypeLabel, type IdentifiersConfig } from '@/features/people';
import { isEmptyString } from '@/utils/string';
import { AutogeneratedAttributeTooltip } from './autogenerated-attribute-tooltip';

/**
 * A row's name and its description.
 *
 * The name leads to the item's own page. Editing the description in place
 * arrives with the rest of the list's write affordances; until then a row with
 * no description shows a dash rather than an invitation it cannot honour.
 */

export type NameCellProps = {
  name: string;
  href: string;
  description: string | null;
  isSensitive: boolean;
  isAutogenerated: boolean;
  /** Only person attributes carry a Reserved or Identifier badge. */
  identifiers: IdentifiersConfig | null | undefined;
  withAttributeBadges: boolean;
};

export function NameCell({
  name,
  href,
  description,
  isSensitive,
  isAutogenerated,
  identifiers,
  withAttributeBadges,
}: NameCellProps) {
  return (
    <Stack>
      <InlineStack alignBlock="center" gap="075">
        <Link variant="primary" href={href} truncate>
          {name}
        </Link>
        {isAutogenerated ? <AutogeneratedAttributeTooltip attribute={name} /> : null}
        {withAttributeBadges ? <AttributeTypeLabel attribute={name} identifiers={identifiers} /> : null}
        {isSensitive ? <Badge color="blue">Sensitive</Badge> : null}
      </InlineStack>
      <Paragraph truncate size="xs" variant={isEmptyString(description) ? 'secondary' : undefined}>
        {isEmptyString(description) ? '-' : description}
      </Paragraph>
    </Stack>
  );
}
